/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SignerType = {
  type: 'Enum',
} as const;
